module.exports = __webpack_public_path__ + "img/logo2.a3933339.png";